import { FringeLearningCenter } from '@/common/containers/Dashboard/Benefits/components/FringeLearningCenter.tsx/FringeLearningCenter';
import { CreditsLearningCenter } from '@/common/containers/Dashboard/Credits/components/CreditsLearningCenter/CreditsLearningCenter';
import { ITMealVoucherLearningCenter } from '@/common/containers/Dashboard/ITMealVoucherLearningCenter/ITMealVoucherLearningCenter';
import { useGetBenefitDetail } from '@/common/integrations/menhir/employee/benefits/benefits.hooks';
import { IOperation } from '@/common/integrations/menhir/employee/operations/operations.types';

export type TOperationsLearningCenterProps = {
  operation: IOperation;
  onClose: () => void;
};

export const OperationsLearningCenter = ({
  operation,
  onClose,
}: TOperationsLearningCenterProps) => {
  const { benefit } = useGetBenefitDetail(
    { slug: operation.categorySlug! },
    { enabled: !!operation.categorySlug }
  );

  const rejectionReason = operation.descriptionParams.find(
    (param) => param.key === 'rejection_reason'
  )?.value;

  if (!benefit) return null;

  if (benefit.slug === 'meals' && rejectionReason === 'not_enough_balance') {
    return <CreditsLearningCenter onClose={onClose} />;
  }

  if (benefit.slug === 'meals') {
    return <ITMealVoucherLearningCenter onClose={onClose} />;
  }

  if (benefit.slug === 'fringe') {
    return <FringeLearningCenter onClose={onClose} />;
  }

  return null;
};
